module.exports = __webpack_public_path__ + "img/icon-file-upload.4fd7836c.svg";